import styled from 'styled-components';

import colors from 'styles/theme/colors';
import AISparkleIcon from 'svg/AISparkleIcon';

import Button, { ButtonProps } from '../Button';

const StyledButton = styled(Button)`
  display: flex;
  gap: 8px;
  background: linear-gradient(90deg, #9686e3 0%, #785bd4 50%, #593ee4 100%);
  background-color: #785bd4;
  color: white;
  border: none;
  font-size: 12px;
  letter-spacing: 0.15px;
  padding: 8px 16px;
  height: 36px;
`;

export default function AIButton({ children, ...props }: React.PropsWithChildren & ButtonProps) {
  return (
    <StyledButton {...props}>
      <AISparkleIcon color={colors.white} /> {children}
    </StyledButton>
  );
}
